(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('.mono-newsletter').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const tags = form.querySelector('[data-mono-tags]');
      const country = form.querySelector('[data-mono-country]');
      const countryField = form.querySelector('[data-country-field]');
      const interest = form.querySelector('[data-mono-interest]');
      const interestField = form.querySelector('[data-interest-field]');
      if (interestField) interestField.hidden = false;
      if (countryField) countryField.hidden = false;
      const updateTags = () => {
        if (!tags) return;
        const values = tags.dataset.baseTags.split(',');
        if (country?.value) values.push(`country:${country.value}`);
        if (interest?.value) values.push(`interest:${interest.value}`);
        const params = new URLSearchParams(window.location.search);
        for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content']) {
          const raw = params.get(key);
          if (raw && /^[a-z0-9_-]{1,64}$/i.test(raw)) values.push(`${key}:${raw.toLowerCase()}`);
        }
        tags.value = values.join(',');
      };
      country?.addEventListener('change', updateTags);
      interest?.addEventListener('change', updateTags);
      form.addEventListener('submit', updateTags);
      updateTags();
    });
  };
  const initialiseScenes = (root = document) => {
    root.querySelectorAll('[data-mono-switch]').forEach(scene => {
      if (scene.dataset.ready) return;
      scene.dataset.ready = 'true';
      const controls = scene.querySelector('[data-scene-controls]');
      if (controls) controls.hidden = false;
      const film = scene.querySelector('video');
      const caption = scene.querySelector('[data-film-caption]');
      const filmError = scene.querySelector('[data-film-error]');
      const updateCaption = () => {
        if (!film || !caption) return;
        caption.textContent = film.currentTime < 2.5 ? caption.dataset.stageOne : film.currentTime < 5 ? caption.dataset.stageTwo : caption.dataset.stageThree;
      };
      film?.addEventListener('timeupdate', updateCaption);
      film?.addEventListener('error', () => { if (filmError) filmError.hidden = false; });
      scene.querySelectorAll('[data-scene-target]').forEach(button => {
        button.addEventListener('click', () => {
          scene.querySelectorAll('[data-scene-target]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
          scene.querySelectorAll('[data-scene-panel]').forEach(panel => {
            panel.hidden = panel.id !== button.dataset.sceneTarget;
            if (panel.hidden) panel.querySelector('video')?.pause();
          });
          if (button.dataset.sceneTarget === 'MonoSceneFilm' && film) {
            if (film.ended) film.currentTime = 0;
            if (filmError) filmError.hidden = true;
            film.play().catch(error => { if (error.name !== 'AbortError' && filmError) filmError.hidden = false; });
          }
        });
      });
    });
  };
  initialiseScenes();
  document.addEventListener('shopify:section:load', event => initialiseScenes(event.target));
  document.querySelectorAll('[data-cookie-preferences]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', async () => {
      const error = document.getElementById('MonoCookieError');
      if (error) error.hidden = true;
      button.disabled = true;
      try {
        if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Banner unavailable');
        await window.privacyBanner.showPreferences();
      } catch {
        if (error) error.hidden = false;
      } finally {
        button.disabled = false;
      }
    });
  });
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.nav-dropdown[open],.mobile-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.querySelectorAll('a[href="#join"]').forEach(link => {
    if (!document.getElementById('join')) link.href = '/pages/launch-updates';
  });
})();
